import React from "react";
import { Modal, Typography, theme } from "antd";
import SubscriptionPlan from "./commons/SubscriptionPlan";

const { Text } = Typography;

const PricingModal = ({
    open,
    onClose,
    onSubscribe,
    onStartTrial,
    onOneTimePurchase,
    loading,
}) => {
    const { token } = theme.useToken();

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={980}
            centered
            styles={{
                header: { padding: 0 },
                body: { padding: "0 28px 28px" },
                content: {
                    borderRadius: 24,
                    overflow: "hidden",
                    padding: 0,
                },
                mask: {
                    backdropFilter: "blur(6px)",
                    background: "rgba(0,0,0,0.35)",
                },
            }}
            closeIcon={
                <div
                    style={{
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: token.colorFillSecondary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 16,
                        color: token.colorTextTertiary,
                        transition: "all 0.2s ease",
                    }}
                >
                    ×
                </div>
            }
            title={
                <div
                    style={{
                        background: `linear-gradient(160deg, ${token.colorPrimary}0a 0%, ${token.colorPrimary}18 50%, transparent 100%)`,
                        borderBottom: `1px solid ${token.colorBorderSecondary}`,
                        padding: "36px 32px 28px",
                        textAlign: "center",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Decorative orbs */}
                    <div
                        style={{
                            position: "absolute",
                            top: -40,
                            left: -40,
                            width: 160,
                            height: 160,
                            borderRadius: "50%",
                            background: `radial-gradient(circle, ${token.colorPrimary}18, transparent 70%)`,
                            pointerEvents: "none",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: -20,
                            right: -20,
                            width: 120,
                            height: 120,
                            borderRadius: "50%",
                            background: `radial-gradient(circle, ${token.colorPrimary}12, transparent 70%)`,
                            pointerEvents: "none",
                        }}
                    />

                    <div
                        style={{
                            fontFamily: "Great Vibes, cursive",
                            fontSize: "2.6rem",
                            fontWeight: "bold",
                            color: token.colorPrimary,
                            lineHeight: 1.2,
                            marginBottom: 8,
                            position: "relative",
                        }}
                    >
                        Choose Your Plan
                    </div>
                    <Text
                        style={{
                            fontSize: 14,
                            color: token.colorTextSecondary,
                            display: "block",
                            position: "relative",
                        }}
                    >
                        Unlock the full power of Qureal — cancel anytime
                    </Text>
                </div>
            }
        >
            <SubscriptionPlan
                onSubscribe={(plan) => {
                    onSubscribe(plan);
                    onClose();
                }}
                onOneTimePurchase={(plan) => {
                    onOneTimePurchase(plan);
                    onClose();
                }}
                onStartTrial={(plan) => {
                    onStartTrial(plan);
                    onClose();
                }}
                loadingSubscription={loading}
            />
        </Modal>
    );
};

export default PricingModal;
